export const DEFAULT_PRINT_SETTINGS = [
  {
    name: "STYLE_COLUMNS",
    value: "2",
  },
  {
    name: "STYLE_ROWS",
    value: "2",
  },
  {
    name: "playTitle",
    value: "Play Name",
  },
  {
    name: "playSubtitle",
    value: "Team",
  },
  {
    name: "PLAY_PER_LINE",
    value: "true",
  },
  {
    name: "PLAY_PER_PAGE",
    value: "true",
  },
  {
    name: "Page #",
    value: "Footer Left",
  },
  {
    name: "pageTitle",
    value: "Playbook Title",
  },
  {
    name: "pageSubtitle",
    value: "Play Name",
  },
  {
    name: "Logo",
    value: "Header Left",
  },
  {
    name: "PLAYBOOK_COVER",
    value: "true",
  },
  {
    name: "CHAPTER_TOC",
    value: "true",
  },
  {
    name: "PLAYBOOK_COVER_INCLUDE_PLAYS",
    value: "true",
  },
];
